import script from "./sf-modal-persistent.vue?vue&type=script&setup=true&lang=ts&generic=ID%20extends%20ModalPortalIdentifier"
export * from "./sf-modal-persistent.vue?vue&type=script&setup=true&lang=ts&generic=ID%20extends%20ModalPortalIdentifier"

import "./sf-modal-persistent.vue?vue&type=style&index=0&id=5ca47135&lang=scss"

const __exports__ = script;

export default __exports__